// Copyright (c) 2025 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Container, Segment, Header, Icon } from 'semantic-ui-react';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
}

function ProtectedRoute({ children }: Readonly<ProtectedRouteProps>) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Container text style={{ marginTop: '100px' }}>
        <Segment placeholder loading>
          <Header icon>
            <Icon name='spinner' loading />
            Loading...
          </Header>
        </Segment>
      </Container>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

export default ProtectedRoute;
